// export DsfNavTab from "./navTab";
// export DsfTabItem from "./tabItem";
// export DsfStepsNav from "./stepsNav";


export const DsfNavTab=dsf.defineLazyComponent('DsfNavTab',()=>require('./navTab.vue'));
export const DsfTabItem=dsf.defineLazyComponent('DsfTabItem',()=>require('./tabItem'));
export const DsfStepsNav=dsf.defineLazyComponent('DsfStepsNav',()=>require('./stepsNav'));